import { css } from "styled-components";
import { bodyColors, bodyShared, handlebodyColor } from "../typography/Body";

export const PStyling = css<{ color?:bodyColors, verticalMargin?:string, fontSize?:string }>`
    ${bodyShared}
    
    margin-top: ${props => props.verticalMargin || '0px'};
    margin-bottom: ${props => props.verticalMargin || '0px'};
    color: ${({ color }) => handlebodyColor(color)}; 
    font-size:${props => props.fontSize || '16px'};
`;

export const SmallStyling = css<{color?:bodyColors, variant?:'neutral'|'normal'}>`
    font-size: 12px;
    color:  ${({ color }) => handlebodyColor(color)};
    font-weight: 400;
`;